import { render, staticRenderFns } from "./ExercisesLibrary.vue?vue&type=template&id=47d69b2b&scoped=true&"
import script from "./ExercisesLibrary.vue?vue&type=script&lang=js&"
export * from "./ExercisesLibrary.vue?vue&type=script&lang=js&"
import style0 from "./ExercisesLibrary.vue?vue&type=style&index=0&id=47d69b2b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47d69b2b",
  null
  
)

export default component.exports